import { html, ref, repeat, when } from "@microsoft/fast-element";
export const ActionsMenuItemTemplate = html `
    ${when((x) => x.isText, html ` <div class="menu-item-text" role="presentation">${(x) => x.title}</div>`)}
    ${when((x) => x.isDivider, html ` <fluent-divider class="menu-item-divider"></fluent-divider>`)}
    ${when((x) => !x.isDivider && !x.isText, html ` <fluent-menu-item
            aria-label="${(x) => (x.ariaLabel ? x.ariaLabel : x.title)}"
            class="menu-item"
            part="menu-item"
            @change=${(x, c) => (x.onClick ? x.onClick(c.event) : x)}
            tabindex="0"
            role="menuitem"
            exportparts="start: action-menu-start"
            id="${(x) => x.id}"
            disabled="${(x) => x.disabled}"
        >
            ${when((x) => x.glyph, html `<span slot="start" class="icon" aria-hidden="true">${(x) => html `${x.glyph}`}</span>`)}
            ${(x) => x.title}
        </fluent-menu-item>`)}
`;
const menuTemplate = html ` <fluent-menu
    ${ref("fluentMenu")}
    @keydown=${(x, c) => x.keyDownHandler(c.event)}
    class="menu"
    part="menu"
>
    ${repeat((x) => x.menuItems, ActionsMenuItemTemplate)}
</fluent-menu>`;
export const actionsMenuTemplate = html ` <template id="action-menu" ${ref("menu")}>
    ${when((x) => x.useFastAnchoredRegion, html ` <fluent-anchored-region
            :anchorElement=${(x) => x.referrerButton || document.body}
            fixed-placement="${(x) => x.fixedPosition}"
            vertical-positioning-mode="dynamic"
            vertical-default-position="${(x) => x.defaultVerticalPosition}"
            horizontal-positioning-mode="dynamic"
            horizontal-default-position="${(x) => x.defaultHorizontalPosition}"
            horizontal-inset="true"
        >
            ${menuTemplate}
        </fluent-anchored-region>`)}
    ${when((x) => !x.useFastAnchoredRegion, html `${menuTemplate}`)}
</template>`;
